<template>
  <div>
    <!-- 右下角浮窗 -->
    <transition name="fade">
      <div v-show="showButton" class="back-to-top" @click="scrollToTop">
        <!-- ↑ -->
      </div>
    </transition>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      showButton: false, // 控制按钮显示
      scrollPosition: 0, // 当前滚动位置
    };
  },
  mounted() {
    // 监听滚动事件（带节流）
    window.addEventListener("scroll", _.throttle(this.handleScroll, 300));
  },
  beforeDestroy() {
    // 销毁事件监听
    window.removeEventListener("scroll", _.throttle(this.handleScroll, 300));
  },
  methods: {
    // 滚动处理
    handleScroll() {
      this.$emit("scrollin", document.documentElement);
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.showButton = this.scrollPosition > 300; // 滚动300px后显示按钮
    },

    // 平滑回到顶部
    scrollToTop() {
      const duration = 500; // 动画时长(ms)
      const start = this.scrollPosition;
      const startTime = performance.now();

      const animateScroll = (timestamp) => {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = progress * (2 - progress); // 缓动函数

        window.scrollTo(0, start * (1 - ease));
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };
      requestAnimationFrame(animateScroll);
    },
  },
};
</script>

<style scoped>
/* 浮窗样式 */
.back-to-top {
  position: fixed;
  right: calc(50vw - 560px - 60px);
  bottom: 30px;
  /* color: white; */
  /* border-radius: 50%; */
  /* text-align: center; */
  /* line-height: 50px; */
  /* font-size: 24px; */
  cursor: pointer;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
  z-index: 1000;
  transition: opacity 0.3s;

  background: url(@/assets/images/uptop.png);
  width: 40px;
  height: 40px;
  background-size: contain;
}

/* 渐入渐出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
